<template>
  <div class="pb-40">
    <div class="mt-6 pt-12 border-t-2 border-gray-300">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'workflow'
}
</script>